import { AlertActions, AlertActionTypes } from './alert.action';
import { cloneDeep } from 'lodash';
import { AlertReduxState } from './alert.redux.state';

export const initialAlertsState: AlertReduxState = new AlertReduxState();

export function alertReducer(state = initialAlertsState, action: AlertActions): AlertReduxState {
  const newState: AlertReduxState = cloneDeep(state);
  switch (action.type) {
    case AlertActionTypes.AddPlaceholder:
      newState.addPlaceholder(action.placeholder);
      return newState;

    case AlertActionTypes.RemovePlaceholder:
      newState.removePlaceholder(action.placeholder);
      return newState;

    case AlertActionTypes.NewAlert:
      newState.addInfo(action.alert);
      return newState;

    case AlertActionTypes.RemoveAlert:
      newState.remove(action.id);
      return newState;

    case AlertActionTypes.ClearPlaceholder:
      newState.remove(action.placeholder);
      return newState;

    default: {
      return newState;
    }
  }
}
